var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXls = function SvgXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".xls_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.5V6.473A5.975 5.975 0 0 0 13.525.5H1.5a1 1 0 0 0-1 1v21a1 1 0 0 0 1 1h3",
    className: "xls_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5.579V4.5a1 1 0 0 0 1 1h3.92M7.5 23.473l4-8M11.5 23.473l-4-8M13.5 15.473v6.5a1.5 1.5 0 0 0 1.5 1.5h2.5M23.5 15.473h-2.146a1.854 1.854 0 0 0-.829 3.513l1.95.975a1.854 1.854 0 0 1-.829 3.512H19.5",
    className: "xls_svg__a"
  })));
};
export default SvgXls;